import { Card, Flex, Tag } from 'antd'

import { GetConsultationResponse } from 'src/api/requests'
import { Text } from 'src/components'
import { useLocales } from 'src/locales'

import { useStyles } from './styles'

type Props = {
  data: GetConsultationResponse
}

export const DetailsPreliminaryCard = ({ data }: Props) => {
  const { t, currentLang } = useLocales()

  const { styles } = useStyles()

  return (
    <Card>
      <Card title={t('consultations.preliminary_information')}>
        <Flex vertical gap={24}>
          {data.preliminaryInformation?.preliminaryDiagnostics?.length && (
            <Flex vertical gap={8}>
              <Text weight={700}>
                {t('consultations.preliminary_diagnostic')}
              </Text>

              <Flex gap={8} wrap="wrap">
                {data.preliminaryInformation.preliminaryDiagnostics.map(
                  (diagnostic) => (
                    <Tag key={diagnostic.id} className={styles.tag}>
                      {diagnostic.translation?.[currentLang.value]}
                    </Tag>
                  )
                )}
              </Flex>
            </Flex>
          )}

          {data.preliminaryInformation?.opportunisticDiseases?.length && (
            <Flex vertical gap={8}>
              <Text weight={700}>{t('treatments.opportunistic_diseases')}</Text>

              <Flex gap={8} wrap="wrap">
                {data.preliminaryInformation.opportunisticDiseases.map(
                  (diagnostic) => (
                    <Tag key={diagnostic.id} className={styles.tag}>
                      {diagnostic.translation?.[currentLang.value]}
                    </Tag>
                  )
                )}
              </Flex>
            </Flex>
          )}

          {data.preliminaryInformation?.notes && (
            <Flex vertical gap={8}>
              <Text weight={700}>{t('form.notes')}</Text>

              <Text>{data.preliminaryInformation.notes}</Text>
            </Flex>
          )}
        </Flex>
      </Card>
    </Card>
  )
}
